import type { PropsWithChildren } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { PageLoader } from '@shared/components/PageLoader';
import { useAuth } from '@/hooks/useAuth';

export const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const { lng = 'es' } = useParams();
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${lng}/login`} replace state={{ from: location }} />;
  }

  return children;
};

export const PublicRoute = ({ children }: PropsWithChildren) => {
  const { lng = 'es' } = useParams();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <PageLoader />;
  }

  if (isAuthenticated) {
    return <Navigate to={`/${lng}/dashboard`} replace />;
  }

  return children;
};
